import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import { apiRequest } from "../../apiServices/allApi";
const $ = require("jquery");
$.Datatable = require("datatables.net");
export default function Bonus() {
  const [data, setUser] = useState([]);
  const id = localStorage.getItem("id");

  const [loading, setLoading] = useState(false);

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);
  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;
    setSearchList(key);
  };

  const fetchData = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/User/bonus_panelty?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`,
        "GET",
        null,
        headers,
      );
      setLoading(false);
      setUser(res.data.admin);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
    } finally {
    }
  };

  const [bonus, setBonus] = useState();

  const update = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    // Step 1: Confirmation box
    const confirmGiveBonus = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to give bonus to this user?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, give bonus",
      cancelButtonText: "Cancel",
    });

    if (!confirmGiveBonus.isConfirmed) {
      return; // Cancelled
    }

    // Step 2: Reason input
    const { value: text } = await Swal.fire({
      input: "textarea",
      inputLabel: "Bonus Reason",
      inputPlaceholder: "Type your reason here...",
      inputAttributes: {
        "aria-label": "Type your reason here",
      },
      showCancelButton: true,
    });

    try {
      if (text) {
        const res = await apiRequest(
          `admin/user_bonus_api/${id}`,
          "POST",
          { bonus: JSON.parse(bonus), reason: text },
          headers,
        );

        // Optional success message
        Swal.fire({
          icon: "success",
          title: "Bonus Given Successfully",
          showConfirmButton: false,
          timer: 1200,
        });

        // Refresh page after small delay
        setTimeout(() => {
          window.location.reload();
        }, 1300);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Enter Reason",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, limit, searchList, searchType]);

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row mt-4">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="dashboard_heading m-0 text-primary">
                  <i className="mdi mdi-gift text-primary mr-2"></i> Bonus
                  Management
                </h4>
                <span className="badge badge-primary px-3 py-2">Bonuses</span>
              </div>
              {/* searching */}
              <div className="admin-filter-bar">
                <select
                  className="form-control"
                  style={{ maxWidth: "180px" }}
                  id="searchType"
                  name="searchtype"
                  onChange={(e) => setSearchType(e.target.value)}
                >
                  <option value="Phone">Search by Phone</option>
                  <option value="Name">Search by Name</option>
                  <option value="_id">Search by User ID</option>
                </select>

                <input
                  type="text"
                  placeholder="Search keyword..."
                  className="form-control"
                  style={{ flex: "1", minWidth: "180px" }}
                  onChange={searchHandler}
                />

                <select
                  className="form-control"
                  
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      {id == "67f8f9731bb8e80965dd62b8" ? <th> ID</th> : ""}
                      <th> Name</th>
                      <th> Mobile </th>
                      <th> Balance </th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {data &&
                      data?.map((data, key) => (
                        <tr role="row" className="odd">
                          <td className="sorting_1">{key + 1}</td>
                          {id == "67f8f9731bb8e80965dd62b8" ? (
                            <td>{data._id}</td>
                          ) : (
                            ""
                          )}
                          <td>{data.Name}</td>
                          {localStorage.getItem("user") === "Admin" ||
                          localStorage.getItem("updateLegalData") === "true" ? (
                            <td>{data.Phone}</td>
                          ) : (
                            <td>{`${
                              "********" + data.Phone.toString().slice(-2)
                            }`}</td>
                          )}
                          <td>{data.Wallet_balance}</td>
                          <td>
                            <div className="row">
                              <div className="col-12 col-lg-5">
                                <input
                                  id="number"
                                  type="number"
                                  className="form-control input-sm"
                                  style={{ minWidth: "100px" }}
                                  placeholder="Amount"
                                  onChange={(e) => setBonus(e.target.value)}
                                />
                              </div>

                              <div className="col-12 col-lg-3">
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => update(data._id)}
                                >
                                  UPDATE
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
